import {StoryTool} from "../StoryTool";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFilePen, faHammer, faNoteSticky} from "@fortawesome/free-solid-svg-icons";
import React from "react";
import {NotesContent} from "./NotesContent";

export class Notes implements StoryTool {
    id = 'notes'
    name = "Notes"
    paths = [
        `/projects/:projectId/stories/:storyId/${this.id}`
    ]
    enabled = false
    icon = <FontAwesomeIcon icon={faNoteSticky}/>
    entryPoint = <NotesContent/>
    link = (projectId?: string, storyId?: string) => `/projects/${projectId}/stories/${storyId}/${this.id}`
}